/*eliminar si se sale del checkout*/
localStorage.removeItem("_c_s_ix");
localStorage.removeItem("_t_ix");

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



// Variantes del detalle del producto


$("#RegisterForm-FirstName").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-LastName").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-email").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$("#RegisterForm-email").keyup(function(){
  if(!$("#tyc").prop("checked")){
    $("#registerAccountBtn").prop("disabled", true);
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});

$(".container-tyc-input input#tyc").change(function(e){
  if(e.target.checked){
  	$("#registerAccountBtn").prop("disabled", false)
    $("#menssage-tratamiento-register").css("display", "none");  
  }else{
  	$("#registerAccountBtn").prop("disabled", true)
    $("#menssage-tratamiento-register").css("display", "block");  
  }
});





// Modificación de las Tallas:

// console.log('GENERO DEL TALLAJE: ', $("#generoTallaje").val());

if($("#generoTallaje").val() == "NINOS") { 
  changeNameTallas("K");
  changeNameTallas("J");
}

// Input hidden Hombre:
if($("#generoTallaje").val() == "HOMBRE"){
  let countItemEstructura = 0;
  
  $(".input-talla").each(function(i){    
    if($(this).val().includes("M")){
      countItemEstructura += 1;
    }
  })
  if(countItemEstructura == 0){
    $(".menu-mujer").attr("style", "display: none");
    $(".menu-hombre").attr("style", "display: block");
  }
  changeNameTallas("H");
  
  $(".menu-hombre").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  //let splitValueActive = options2[0].split("-");
  //document.getElementById("valueTalla").innerHTML = splitValueActive[0].replace("H","");
}else if($("#generoTallaje").val() == "MUJER"){

  let countItemEstructura = 0;
  $(".input-talla").each(function(i){
    if($(this).val().charAt(0) == "H"){
      countItemEstructura += 1;
    }
  })
  

  if(countItemEstructura == 0){
    $(".menu-hombre").attr("style", "display: none");
    $(".menu-mujer").attr("style", "display: block");
  }
  changeNameTallas("M");
  $(".menu-mujer").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  //let splitValueActive = options2[0].split("-");
  //document.getElementById("valueTalla").innerHTML = splitValueActive[1].replace("M","");
} else { //Unisex

  // console.log('1. Unisex');
  
  $(".input-talla").each(function(i){
    if($(this).val().charAt(0) == "H"){
      // Muestra el menú de Hombre y Mujer: 
      $(".menu-mujer-unisex").attr("style", "display: block;");
      $(".menu-hombre-unisex").attr("style", "display: block;  box-shadow: inset 0 -2px 0 0 #000;");

      $(".menu-hombre-unisex").attr("data-selected-gender", "hombre");
      $(".menu-mujer-unisex").attr("data-selected-gender", "");


      $(".input-talla").each(function(i){
        
        let arrayValues;
        if($(this).val().search("/") != -1){ //Si la tiene.
          arrayValues = $(this).val().toUpperCase().split("/");
        }else{
          arrayValues = $(this).val().toUpperCase().split("-");
        }

        for (let index = 0; index < arrayValues.length; index++) {
          let value = arrayValues[index];
          if(value.charAt(0) == "H"){
            $(this).attr("data-seleccionada", arrayValues[index]);
            $(".item-talla").eq(i).text(arrayValues[index].replace("H", ""));
          }
          
        }
      })
      sortElementSelect('.content-tallas');
      
    }else if($(this).val().charAt(0) == "M"){
      $(".input-talla").each(function(i){

        let arrayValues;
        if($(this).val().search("/") != -1){ //Si la tiene.
          arrayValues = $(this).val().toUpperCase().split("/");
        }else{
          arrayValues = $(this).val().toUpperCase().split("-");
        }

        for (let index = 0; index < arrayValues.length; index++) {
          let value = arrayValues[index];
          if(value.charAt(0) == "M"){
            $(this).attr("data-seleccionada", arrayValues[index]);
            $(".item-talla").eq(i).text(arrayValues[index].replace("M", ""));
          }
        }
      })
      sortElementSelect('.content-tallas');
    }else{
      $(this).attr("data-seleccionada", $(this).val());
      changeNameTallas("");
    }
  })
}

$(".menu-hombre").click(function(){
  changeNameTallas("H");
  $(".menu-hombre").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-mujer").attr("style", "box-shadow: none;");
})

$(".menu-mujer").click(function(){
  changeNameTallas("M");
  $(".menu-mujer").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-hombre").attr("style", "box-shadow: none;");
})


/* Comentado mientras*/

  // let man_action = document.getElementById('mhu');
  // if(man_action === null){
  //   let selected_gender = 'ninos';
  //   localStorage.setItem('size_type', 'us');
  //   let size_type = 'us';
  //   console.log('Genero Seleccionado: ', selected_gender);
  //    if(size_type){
  //     let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
  //     if(size_type === 'eu'){
  //         assignSizeValuesPDP(sizes_values, selected_gender, size_type);
  //     } else if (size_type === 'us') {
  //         assignSizeValuesPDP(sizes_values, selected_gender, size_type);
  //     }
  //   }
  // }


$(".menu-hombre-unisex").click(function(){
  changeNameTallas("H");
  $(".input-talla").each(function(e, i){
    if($(this).val().indexOf("H") == -1){
      $(this).parent().attr("style", "display: none");
    }else{
      $(this).parent().attr("style", "display: block");       
     
    }
  })
  $(".menu-hombre-unisex").attr("style", "display: block; box-shadow: inset 0 -2px 0 0 #000;"); 
  $(".menu-mujer-unisex").attr("style", "display: block; box-shadow: none;");

  $(".menu-hombre-unisex").attr("data-selected-gender", "hombre");
  $(".menu-mujer-unisex").attr("data-selected-gender", "");

  let man_action = document.getElementById('mhu');
  let selected_gender;

  let size_type = localStorage.getItem('size_type');

  if(!size_type){
    localStorage.setItem('size_type', 'us');
  }

  if(man_action.dataset.selectedGender === 'hombre') {
    selected_gender = 'hombre';
    // console.log('Tiene seleccionado el género hombre.');
  }else{
    selected_gender = 'mujer';
    // console.log('Tiene seleccionado el género mujer.');
  }

  // console.log('Genero Seleccionado: ', selected_gender);

  if(size_type){
    let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
    if(size_type === 'eu'){
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    } else if (size_type === 'us') {
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    }
  }

})


// let arreglo_tallas_reales = [];

$(".menu-mujer-unisex").click(function(){
  changeNameTallas("M");
  $(".input-talla").each(function(e, i){
    if($(this).val().indexOf("M") == -1){
      $(this).parent().attr("style", "display: none");
    }else{
      $(this).parent().attr("style", "display: block");
      
    }
  })
  $(".menu-mujer-unisex").attr("style", "display: block; box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-hombre-unisex").attr("style", "display: block; box-shadow: none;");

  $(".menu-mujer-unisex").attr("data-selected-gender", "mujer");
  $(".menu-hombre-unisex").attr("data-selected-gender", "");

  let man_action = document.getElementById('mhu');
  let selected_gender;
  let size_type = localStorage.getItem('size_type');

  if(!size_type){
    localStorage.setItem('size_type', 'us');
  }

  if(man_action.dataset.selectedGender === 'hombre') {
    selected_gender = 'hombre';
    // console.log('Tiene seleccionado el género hombre.');
  }else{
    selected_gender = 'mujer';
    // console.log('Tiene seleccionado el género mujer.');
  }

  if(size_type){
    let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
    if(size_type === 'eu'){
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    } else if (size_type === 'us') {
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    }
  }
})

// Tallas del carrito:

$(".value-variant-talla").each(function(i){

  let arrayValues; 
  // let arrayValues = $(this).attr("data-val-talla").trim().split("-");  
  if($(this).attr("data-val-talla").search("/") != -1){ //Si la tiene.
    arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("/");     
  }else{
    arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("-");  
  }
  
  for (let index = 0; index < arrayValues.length; index++) {
    let value = arrayValues[index];     
    if(value.charAt(0) == $(this).attr("data-genero")){
      $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
    }else if ($(this).attr("data-genero") == "unisex"){
      if($(this).parent().parent().find(".value-properties-product").find("dd").text().charAt(0) == "H"){
        $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
      }else{
        $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
      }
    }else{
      $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
    }
  }
})

/*Cuando vienen sin el prefijo de sexo H o M*/
$(".input-talla").click(function(){
  if($(this).val().indexOf("M") == -1 && $(this).val().indexOf("H") == -1){
    $(this).attr("data-seleccionada", $(this).val());  
  }else{
    if($(".menu-hombre-unisex").length > 0){
      if($(".menu-hombre-unisex").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
        $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
      }else{
        $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
      }
    }else{
      $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
    }
    
    if($("#generoTallaje").val() == "MUJER"){
      if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
        if($(".menu-hombre").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
        }
      }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
        if($(".menu-mujer").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
        }
      }
    }
    
    if($("#generoTallaje").val() == "HOMBRE"){
      if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
        if($(".menu-hombre").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
        }
      }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
        if($(".menu-mujer").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
        }
      }
    }
  }
});




function changeNameTallas(type){
  $(".input-talla").each(function(i){

    // console.log($(this).val());    

    let arrayValues;
    if($(this).val().search("/") != -1){ //Si la tiene.
      arrayValues = $(this).val().trim().toUpperCase().split("/");
    }else{
      arrayValues = $(this).val().trim().toUpperCase().split("-");
    }
    for (let index = 0; index < arrayValues.length; index++) {
      let value = arrayValues[index];
      if(value.charAt(0) == type){
        $(this).attr("data-seleccionada", arrayValues[index]);
        $(".item-talla").eq(i).text(arrayValues[index].replace(type, ""));
      }
    }
    // $(this).attr("data-seleccionada", "");
  });

  sortElementSelect('.content-tallas');
}

function sortElementSelect(idList){
	var $myList = $(idList);
  	
    var $item = $myList.children('.container-item-talla');

    var sortList = Array.prototype.sort.bind($item);
  
  	
    sortList(function ( a, b ) {		
        // Cache inner content from the first element (a) and the next sibling (b)
        var aText = a.children[1].innerText;
        var bText = b.children[1].innerText;

        // Returning -1 will place element `a` before element `b`
        if ( aText < bText ) {
            return -1;
        }

        // Returning 1 will do the opposite
        if ( aText > bText ) {
            return 1;
        }

        // Returning 0 leaves them as-is
        return 0;
    });
      
    $myList.append($item);
}

/** Fin de Tallas **/ 


/* Modificación de funcionalidad de SALE en el submenú */

window.addEventListener('load', () => {
  let menu_mobile_sale = document.querySelector('#main-menu-mobile .gm-item a[title="SALE"]');
  
  menu_mobile_sale?.addEventListener('click', () => {
    window.location.href = 'https://crocs.cr/collections/sale';
  });
});


 /* Cambiar texto de los Metacampos a Customer Hub App */ 
 window.addEventListener('load', () => {
  if(location.pathname ==='/account'){
    let customer_info = document.querySelector("#chShowAddress-Block > div:nth-child(2) > div.chContent-BPCBI-Content > div.chContent-BPCBI-Content-Address > div.chcf_load_el").childNodes;
    customer_info.forEach((e) => {  
      switch (e.querySelector('.chcf_el_label').textContent) {
        case 'birthday':
          e.querySelector('.chcf_el_label').textContent = 'Cumpleaños';
          break;
        case 'gender':
          e.querySelector('.chcf_el_label').textContent = 'Género';
          break;
        case 'department':
          e.querySelector('.chcf_el_label').textContent = 'Provincia';
        break;
        case 'city':
          e.querySelector('.chcf_el_label').textContent = 'Cantón';
        break;       
        case 'district':
          e.querySelector('.chcf_el_label').textContent = 'Distrito';
        break;
      }
    });  

   

  }  

  if(location.pathname ==='/account/addresses'){
    chMfHolder_birthday.firstChild.textContent = 'Cumpleaños';
    chMfHolder_gender.firstChild.textContent = 'Género';
    chMfHolder_department.firstChild.textContent = 'Provincia';
    chMfHolder_city.firstChild.textContent = 'Cantón';
    chMfHolder_district.firstChild.textContent = 'Distrito';
    

    chMfHolder_gender.querySelector('textarea').addEventListener('keyup', (e) => {
      e.target.value = e.target.value.toUpperCase()
      
      // if(!e.target.value.includes('MASCULINO') || !e.target.value.includes('FEMENINO')){
      //   e.target.value = 'MASCULINO';
      // }
    });
  }

  if(location.href === 'https://crocs.cr/account/addresses?a=profile'){
    // console.log(location.href);
    // chMfHolder_gender.style.display = 'none';
    let gender_customer_options = ['MASCULINO', 'FEMENINO'];
    let department_customer, city_customer ;

    department_customer = chMfHolder_department.querySelector('textarea').value.trim();
    department_city = chMfHolder_city.querySelector('textarea').value.trim();


    var user_location_conf = {
      "provincia": { "id": 0, "nombre": ""},
         "canton": { "id": 0, "nombre": ""},
       "distrito": { "id": 0, "nombre": ""},
    }
     
        
       
    


    // Costa Rica Array
    var costa_rica = [
      {
          "provincias": {
              "1": {
                  "nombre": "San José",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Carmen",
                              "2": "Merced",
                              "3": "Hospital",
                              "4": "Catedral",
                              "5": "Zapote",
                              "6": "San Francisco De Dos Rios",
                              "7": "Uruca",
                              "8": "Mata Redonda",
                              "9": "Pavas",
                              "10": "Hatillo",
                              "11": "San Sebastián"
                          }
                      },
                      "2": {
                          "nombre": "Escazú",
                          "distritos": {
                              "1": "Escazú",
                              "2": "San Antonio",
                              "3": "San Rafael"
                          }
                      },
                      "3": {
                          "nombre": "Desamparados",
                          "distritos": {
                              "1": "Desamparados",
                              "2": "San Miguel",
                              "3": "San Juan De Dios",
                              "4": "San Rafael Arriba",
                              "5": "San Rafael Abajo",
                              "6": "San Antonio",
                              "7": "Frailes",
                              "8": "Patarra",
                              "9": "San Cristobal",
                              "10": "Rosario",
                              "11": "Damas",
                              "12": "Gravilias",
                              "13": "Los Guido"
                          }
                      },
                      "4": {
                          "nombre": "Puriscal",
                          "distritos": {
                              "1": "Santiago",
                              "2": "Mercedes Sur",
                              "3": "Barbacoas",
                              "4": "Grifo Alto",
                              "5": "San Rafael",
                              "6": "Candelarita",
                              "7": "Desamparaditos",
                              "8": "San Antonio",
                              "9": "Chires"
                          }
                      },
                      "5": {
                          "nombre": "Tarrazú",
                          "distritos": {
                              "1": "San Marcos",
                              "2": "San Lorenzo",
                              "3": "San Carlos"
                          }
                      },
                      "6": {
                          "nombre": "Aserrí",
                          "distritos": {
                              "1": "Aserrí",
                              "2": "Tarbaca",
                              "3": "Vuelta De Jorco",
                              "4": "San Gabriel",
                              "5": "Legua",
                              "6": "Monterrey",
                              "7": "Salitrillos"
                          }
                      },
                      "7": {
                          "nombre": "Mora",
                          "distritos": {
                              "1": "Colón",
                              "2": "Guayabo",
                              "3": "Tabarcia",
                              "4": "Piedras Negras",
                              "5": "Picagres",
                              "6": "Jaris"
                          }
                      },
                      "8": {
                          "nombre": "Goicoechea",
                          "distritos": {
                              "1": "Guadalupe",
                              "2": "San Francisco",
                              "3": "Calle Blancos",
                              "4": "Mata De Platano",
                              "5": "Ipís",
                              "6": "Rancho Redondo",
                              "7": "Purral"
                          }
                      },
                      "9": {
                          "nombre": "Santa Ana",
                          "distritos": {
                              "1": "Santa Ana",
                              "2": "Salitral",
                              "3": "Pozos",
                              "4": "Uruca",
                              "5": "Piedades",
                              "6": "Brasil"
                          }
                      },
                      "10": {
                          "nombre": "Alajuelita",
                          "distritos": {
                              "1": "Alajuelita",
                              "2": "San Josecito",
                              "3": "San Antonio",
                              "4": "Concepción",
                              "5": "San Felipe"
                          }
                      },
                      "11": {
                          "nombre": "Vázquez De Coronado",
                          "distritos": {
                              "1": "San Isidro",
                              "2": "San Rafael",
                              "3": "Dulce Nombre De Jesus",
                              "4": "Patalillo",
                              "5": "Cascajal"
                          }
                      },
                      "12": {
                          "nombre": "Acosta",
                          "distritos": {
                              "1": "San Ignacio",
                              "2": "Guaitil",
                              "3": "Palmichal",
                              "4": "Cangrejal",
                              "5": "Sabanillas"
                          }
                      },
                      "13": {
                          "nombre": "Tibás",
                          "distritos": {
                              "1": "San Juan",
                              "2": "Cinco Esquinas",
                              "3": "Anselmo Llorente",
                              "4": "Leon XII",
                              "5": "Colima"
                          }
                      },
                      "14": {
                          "nombre": "Moravia",
                          "distritos": {
                              "1": "San Vicente",
                              "2": "San Jeronimo",
                              "3": "La Trinidad"
                          }
                      },
                      "15": {
                          "nombre": "Montes De Oca",
                          "distritos": {
                              "1": "San Pedro",
                              "2": "Sabanilla",
                              "3": "Mercedes",
                              "4": "San Rafael"
                          }
                      },
                      "16": {
                          "nombre": "Turrubares",
                          "distritos": {
                              "1": "San Pablo",
                              "2": "San Pedro",
                              "3": "San Juan De Mata",
                              "4": "San Luis",
                              "5": "Carara"
                          }
                      },
                      "17": {
                          "nombre": "Dota",
                          "distritos": {
                              "1": "Santa María",
                              "2": "Jardin",
                              "3": "Copey"
                          }
                      },
                      "18": {
                          "nombre": "Curridabat",
                          "distritos": {
                              "1": "Curridabat",
                              "2": "Granadilla",
                              "3": "Sanchez",
                              "4": "Tirrases"
                          }
                      },
                      "19": {
                          "nombre": "Pérez Zeledón",
                          "distritos": {
                              "1": "San Isidro De El General",
                              "2": "El General",
                              "3": "Daniel Flores",
                              "4": "Rivas",
                              "5": "San Pedro",
                              "6": "Platanares",
                              "7": "Pejibaye",
                              "8": "Cajon",
                              "9": "Baru",
                              "10": "Rio Nuevo",
                              "11": "Páramo"
                          }
                      },
                      "20": {
                          "nombre": "León Cortés Castro",
                          "distritos": {
                              "1": "San Pablo",
                              "2": "San Andres",
                              "3": "Llano Bonito",
                              "4": "San Isidro",
                              "5": "Santa Cruz",
                              "6": "San Antonio"
                          }
                      }
                  }
              },
              "2": {
                  "nombre": "Alajuela",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Alajuela",
                              "2": "San José",
                              "3": "Carrizal",
                              "4": "San Antonio",
                              "5": "Guácima",
                              "6": "San Isidro",
                              "7": "Sabanilla",
                              "8": "San Rafael",
                              "9": "Rio Segundo",
                              "10": "Desamparados",
                              "11": "Turrucares",
                              "12": "Tambor",
                              "13": "Garita",
                              "14": "Sarapiquí"
                          }
                      },
                      "2": {
                          "nombre": "San Ramón",
                          "distritos": {
                              "1": "San Ramón",
                              "2": "Santiago",
                              "3": "San Juan",
                              "4": "Piedades Norte",
                              "5": "Piedades Sur",
                              "6": "San Rafael",
                              "7": "San Isidro",
                              "8": "Angeles",
                              "9": "Alfaro",
                              "10": "Volio",
                              "11": "Concepción",
                              "12": "Zapotal",
                              "13": "Peñas Blancas"
                          }
                      },
                      "3": {
                          "nombre": "Grecia",
                          "distritos": {
                              "1": "Grecia",
                              "2": "San Isidro",
                              "3": "San José",
                              "4": "San Roque",
                              "5": "Tacares",
                              "6": "Rio Cuarto",
                              "7": "Puente De Piedra",
                              "8": "Bolivar"
                          }
                      },
                      "4": {
                          "nombre": "San Mateo",
                          "distritos": {
                              "1": "San Mateo",
                              "2": "Desmonte",
                              "3": "Jesús María",
                              "4": "Labrador"
                          }
                      },
                      "5": {
                          "nombre": "Atenas",
                          "distritos": {
                              "1": "Atenas",
                              "2": "Jesús",
                              "3": "Mercedes",
                              "4": "San Isidro",
                              "5": "Concepción",
                              "6": "San José",
                              "7": "Santa Eulalia",
                              "8": "Escobal"
                          }
                      },
                      "6":{
                          "nombre": "Naranjo",
                          "distritos": {
                              "1": "Naranjo",
                              "2": "San Miguel",
                              "3": "San José",
                              "4": "Cirrí Sur",
                              "5": "San Jerónimo",
                              "6": "San Juan",
                              "7": "El Rosario",
                              "8": "Palmitos"
                          }
                      },
                      "7": {
                          "nombre": "Palmares",
                          "distritos": {
                              "1": "Palmares",
                              "2": "Zaragoza",
                              "3": "Buenos Aires",
                              "4": "Santiago",
                              "5": "Candelaria",
                              "6": "Esquipulas",
                              "7": "La Granja"
                          }
                      },
                      "8": {
                          "nombre": "Poás",
                          "distritos": {
                              "1": "San Pedro",
                              "2": "San Juan",
                              "3": "San Rafael",
                              "4": "Carrillos",
                              "5": "Sabana Redonda"
                          }
                      },
                      "9": {
                          "nombre": "Orotina",
                          "distritos": {
                              "1": "Orotina",
                              "2": "El Mastate",
                              "3": "Hacienda Vieja",
                              "4": "Coyolar",
                              "5": "La Ceiba"
                          }
                      },
                      "10": {
                          "nombre": "San Carlos",
                          "distritos": {
                              "1": "Quesada",
                              "2": "Florencia",
                              "3": "Buenavista",
                              "4": "Aguas Zarcas",
                              "5": "Venecia",
                              "6": "Pital",
                              "7": "La Fortuna",
                              "8": "La Tigra",
                              "9": "La Palmera",
                              "10": "Venado",
                              "11": "Cutris",
                              "12": "Monterrey",
                              "13": "Pocosol"
                          }
                      },
                      "11": {
                          "nombre": "Zarcero",
                          "distritos": {
                              "1": "Zarcero",
                              "2": "Laguna",
                              "3": "Tapesco",
                              "4": "Guadalupe",
                              "5": "Palmira",
                              "6": "Zapote",
                              "7": "Brisas"
                          }
                      },
                      "12": {
                          "nombre": "Sarchí",
                          "distritos": {
                              "1": "Sarchí Norte",
                              "2": "Sarchí Sur",
                              "3": "Toro Amarillo",
                              "4": "San Pedro",
                              "5": "Rodriguez"
                          }
                      },
                      "13": {
                          "nombre": "Upala",
                          "distritos": {
                              "1": "Upala",
                              "2": "Aguas Claras",
                              "3": "San José o Pizote",
                              "4": "Bijagua",
                              "5": "Delicias",
                              "6": "Dos Rios",
                              "7": "Yolillal",
                              "8": "Canalete"
                          }
                      },
                      "14": {
                          "nombre": "Los Chiles",
                          "distritos": {
                              "1": "Los Chiles",
                              "2": "Caño Negro",
                              "3": "El Amparo",
                              "4": "San Jorge"
                          }
                      },
                      "15": {
                          "nombre": "Guatuso",
                          "distritos": {
                              "1": "San Rafael",
                              "2": "Buenavista",
                              "3": "Cote",
                              "4": "Katira"
                          }
                      },
                      "16": {
                          "nombre": "Río Cuarto",
                          "distritos": {
                              "1": "Río Cuarto"
                          }
                      }
                  }
              },
              "3": {
                  "nombre": "Cartago",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Oriental",
                              "2": "Occidental",
                              "3": "Carmen",
                              "4": "San Nicolás",
                              "5": "Aguacaliente o San Francisco",
                              "6": "Guadalupe o Arenilla",
                              "7": "Corralillo",
                              "8": "Tierra Blanca",
                              "9": "Dulce Nombre",
                              "10": "Llano Grande",
                              "11": "Quebradilla"
                          }
                      },
                      "2": {
                          "nombre": "Paraíso",
                          "distritos": {
                              "1": "Paraiso",
                              "2": "Santiago",
                              "3": "Orosi",
                              "4": "Cachí",
                              "5": "Llanos de Santa Lucía"
                          }
                      },
                      "3": {
                          "nombre": "La Unión",
                          "distritos": {
                              "1": "Tres Rios",
                              "2": "San Diego",
                              "3": "San Juan",
                              "4": "San Rafael",
                              "5": "Concepción",
                              "6": "Dulce Nombre",
                              "7": "San Ramón",
                              "8": "Rio Azul"
                          }
                      },
                      "4": {
                          "nombre": "Jiménez",
                          "distritos": {
                              "1": "Juan Viñas",
                              "2": "Tucurrique",
                              "3": "Pejibaye"
                          }
                      },
                      "5": {
                          "nombre": "Turrialba",
                          "distritos": {
                              "1": "Turrialba",
                              "2": "La Suiza",
                              "3": "Peralta",
                              "4": "Santa Cruz",
                              "5": "Santa Teresita",
                              "6": "Pavones",
                              "7": "Tuis",
                              "8": "Tayutic",
                              "9": "Santa Rosa",
                              "10": "Tres Equis",
                              "11": "La Isabel",
                              "12": "Chirripó"
                          }
                      },
                      "6": {
                          "nombre": "Alvarado",
                          "distritos": {
                              "1": "Pacayas",
                              "2": "Cervantes",
                              "3": "Capellades"
                          }
                      },
                      "7": {
                          "nombre": "Oreamuno",
                          "distritos": {
                              "1": "San Rafael",
                              "2": "Cot",
                              "3": "Potrero Cerrado",
                              "4": "Cipreses",
                              "5": "Santa Rosa"
                          }
                      },
                      "8": {
                          "nombre": "El Guarco",
                          "distritos": {
                              "1": "El Tejar",
                              "2": "San Isidro",
                              "3": "Tobosi",
                              "4": "Patio De Agua"
                          }
                      }
                  }
              },
              "4": {
                  "nombre": "Heredia",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Heredia",
                              "2": "Mercedes",
                              "3": "San Francisco",
                              "4": "Ulloa",
                              "5": "Varablanca"
                          }
                      },
                      "2": {
                          "nombre": "Barva",
                          "distritos": {
                              "1": "Barva",
                              "2": "San Pedro",
                              "3": "San Pablo",
                              "4": "San Roque",
                              "5": "Santa Lucía",
                              "6": "San José de la Montaña"
                          }
                      },
                      "3": { 
                          "nombre": "Santo Domingo",
                          "distritos": {
                              "1": "Santo Domingo",
                              "2": "San Vicente",
                              "3": "San Miguel",
                              "4": "Paracito",
                              "5": "Santo Tomás",
                              "6": "Santa Rosa",
                              "7": "Tures",
                              "8": "Para"
                          }
                      },
                      "4": { 
                          "nombre": "Santa Barbara",
                          "distritos": {
                              "1": "Santa Bárbara",
                              "2": "San Pedro",
                              "3": "San Juan",
                              "4": "Jesús",
                              "5": "Santo Domingo",
                              "6": "Puraba"
                          }
                      },
                      "5": { 
                          "nombre": "San Rafael",
                          "distritos": {
                              "1": "San Rafael",
                              "2": "San Josecito",
                              "3": "Santiago",
                              "4": "Los Ángeles",
                              "5": "Concepción"
                          }
                      },
                      "6": { 
                          "nombre": "San Isidro",
                          "distritos": {
                              "1": "San Isidro",
                              "2": "San José",
                              "3": "Concepción",
                              "4": "San Francisco"
                          }
                      },
                      "7": { 
                          "nombre": "Belén",
                          "distritos": {
                              "1": "San Antonio",
                              "2": "La Ribera",
                              "3": "La Asuncion"
                          }
                      },
                      "8": { 
                          "nombre": "Flores",
                          "distritos": {
                              "1": "San Joaquín",
                              "2": "Barrantes",
                              "3": "Llorente"
                          }
                      },
                      "9": { 
                          "nombre": "San Pablo",
                          "distritos": {
                              "1": "San Pablo",
                              "2": "Rincon De Sabanilla"
                          }
                      },
                      "10": { 
                          "nombre": "Sarapiquí",
                          "distritos": {
                              "1": "Puerto Viejo",
                              "2": "La Virgen",
                              "3": "Las Horquetas",
                              "4": "Llanuras Del Gaspar",
                              "5": "Cureña"
                          }
                      }
                  }
              },
              "5": {
                  "nombre": "Guanacaste",
                  "cantones": {
                      "1": {
                          "nombre": "Liberia",
                          "distritos": {
                              "1": "Liberia",
                              "2": "Cañas Dulces",
                              "3": "Mayorga",
                              "4": "Nacascolo",
                              "5": "Curubande"
                          }
                      },
                      "2": {
                          "nombre": "Nicoya",
                          "distritos": {
                              "1": "Nicoya",
                              "2": "Mansión",
                              "3": "San Antonio",
                              "4": "Quebrada Honda",
                              "5": "Sámara",
                              "6": "Nosara",
                              "7": "Belén De Nosarita"
                          }
                      },
                      "3": {
                          "nombre": "Santa Cruz",
                          "distritos": {
                              "1": "Santa Cruz",
                              "2": "Bolson",
                              "3": "Veintisiete de Abril",
                              "4": "Tempate",
                              "5": "Cartagena",
                              "6": "Cuajiniquil",
                              "7": "Diria",
                              "8": "Cabo Velas",
                              "9": "Tamarindo"
                          }
                      },
                      "4": {
                          "nombre": "Bagaces",
                          "distritos": {
                              "1": "Bagaces",
                              "2": "La Fortuna",
                              "3": "Mogote",
                              "4": "Rio Naranjo"
                          }
                      },
                      "5": {
                          "nombre": "Carrillo",
                          "distritos": {
                              "1": "Filadelfia",
                              "2": "Palmira",
                              "3": "Sardinal",
                              "4": "Belen"
                          }
                      },
                      "6": {
                          "nombre": "Cañas",
                          "distritos": {
                              "1": "Cañas",
                              "2": "Palmira",
                              "3": "San Miguel",
                              "4": "Bebedero",
                              "5": "Porozal"
                          }
                      },
                      "7": {
                          "nombre": "Abangares",
                          "distritos": {
                              "1": "Las Juntas",
                              "2": "Sierra",
                              "3": "San Juan",
                              "4": "Colorado"
                          }
                      },
                      "8": {
                          "nombre": "Tilarán",
                          "distritos": {
                              "1": "Tilarán",
                              "2": "Quebrada Grande",
                              "3": "Tronadora",
                              "4": "Santa Rosa",
                              "5": "Líbano",
                              "6": "Tierras Morenas",
                              "7": "Arenal"
                          }
                      },
                      "9": {
                          "nombre": "Nandayure",
                          "distritos": {
                              "1": "Carmona",
                              "2": "Santa Rita",
                              "3": "Zapotal",
                              "4": "San Pablo",
                              "5": "Porvenir",
                              "6": "Bejuco"
                          }
                      },
                      "10": {
                          "nombre": "La Cruz",
                          "distritos": {
                              "1": "La Cruz",
                              "2": "Santa Cecilia",
                              "3": "La Garita",
                              "4": "Santa Elena"
                          }
                      },
                      "11": {
                          "nombre": "Hojancha",
                          "distritos": {
                              "1": "Hojancha",
                              "2": "Monte Romo",
                              "3": "Puerto Carrillo",
                              "4": "Huacas"
                          }
                      }
                  }
              },
              "6": {
                  "nombre": "Puntarenas",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Puntarenas",
                              "2": "Pitahaya",
                              "3": "Chomes",
                              "4": "Lepanto",
                              "5": "Paquera",
                              "6": "Manzanillo",
                              "7": "Guacimal",
                              "8": "Barranca",
                              "9": "Monte Verde",
                              "10": "Isla Del Coco",
                              "11": "Cóbano",
                              "12": "Chacarita",
                              "13": "Chira",
                              "14": "Acapulco",
                              "15": "El Roble",
                              "16": "Arancibia"
                          }
                      },
                      "2": {
                          "nombre": "Esparza",
                          "distritos": {
                              "1": "Espíritu Santo",
                              "2": "San Juan Grande",
                              "3": "Macacona",
                              "4": "San Rafael",
                              "5": "San Jerónimo"
                          }
                      },
                      "3": {
                          "nombre": "Buenos Aires",
                          "distritos": {
                              "1": "Buenos Aires",
                              "2": "Volcán",
                              "3": "Potrero Grande",
                              "4": "Boruca",
                              "5": "Pilas",
                              "6": "Colinas",
                              "7": "Changuena",
                              "8": "Biolley",
                              "9": "Brunka"
                          }
                      },
                      "4": {
                          "nombre": "Montes De Oro",
                          "distritos": {
                              "1": "Miramar",
                              "2": "La Unión",
                              "3": "San Isidro"
                          }
                      },
                      "5": {
                          "nombre": "Osa",
                          "distritos": {
                              "1": "Puerto Cortés",
                              "2": "Palmar",
                              "3": "Sierpe",
                              "4": "Bahía Ballena",
                              "5": "Piedras Blancas",
                              "6": "Bahía Drake"
                          }
                      },
                      "6": {
                          "nombre": "Quepos",
                          "distritos": {
                              "1": "Quepos",
                              "2": "Savegre",
                              "3": "Naranjito"
                          }
                      },
                      "7": {
                          "nombre": "Golfito",
                          "distritos": {
                              "1": "Golfito",
                              "2": "Puerto Jiménez",
                              "3": "Guaycara",
                              "4": "Pavón"
                          }
                      },
                      "8": {
                          "nombre": "Coto Brus",
                          "distritos": {
                              "1": "San Vito",
                              "2": "Sabalito",
                              "3": "Aguabuena",
                              "4": "Limoncito",
                              "5": "Pittier"
                          }
                      },
                      "9": {
                          "nombre": "Parrita",
                          "distritos": {
                              "1": "Parrita"
                          }
                      },
                      "10": {
                          "nombre": "Corredores",
                          "distritos": {
                              "1": "Corredor",
                              "2": "La Cuesta",
                              "3": "Canoas",
                              "4": "Laurel"
                          }
                      },
                      "11": {
                          "nombre": "Garabito",
                          "distritos": {
                              "1": "Jacó",
                              "2": "Tárcoles"
                          }
                      }
                  }
              },
              "7": {
                  "nombre": "Limón",
                  "cantones": {
                      "1": {
                          "nombre": "Central",
                          "distritos": {
                              "1": "Limón",
                              "2": "Valle La Estrella",
                              "3": "Rio Blanco",
                              "4": "Matama"
                          }
                      },
                      "2": {
                          "nombre": "Pococí",
                          "distritos": {
                              "1": "Guapiles",
                              "2": "Jiménez",
                              "3": "Rita",
                              "4": "Roxana",
                              "5": "Cariari",
                              "6": "Colorado",
                              "7": "La Colonia"
                          }
                      },
                      "3": {
                          "nombre": "Siquirres",
                          "distritos": {
                              "1": "Siquirres",
                              "2": "Pacuarito",
                              "3": "Florida",
                              "4": "Germania",
                              "5": "El Cairo",
                              "6": "Alegría"
                          }
                      },
                      "4": { 
                          "nombre": "Talamanca",
                          "distritos": {
                              "1": "Bratsi",
                              "2": "Sixaola",
                              "3": "Cahuita",
                              "4": "Telire"
                          }
                      },
                      "5": {
                          "nombre": "Matina",
                          "distritos": {
                              "1": "Matina",
                              "2": "Batán",
                              "3": "Carrandi"
                          }
                      },
                      "6": {
                          "nombre": "Guácimo",
                          "distritos": {
                              "1": "Guácimo",
                              "2": "Mercedes",
                              "3": "Pocora",
                              "4": "Rio Jiménez",
                              "5": "Duacari"
                          }
                      }
                  }
              }
          }
      }
    ];
    
    chMfHolder_gender.querySelector('textarea').style.display = 'none';
    // chMfHolder_department.querySelector('textarea').style.display = 'none';
    // chMfHolder_city.querySelector('textarea').style.display = 'none';
    // chMfHolder_district.querySelector('textarea').style.display = 'none';

    chMfHolder_gender.querySelector('.chContent-BPG-group-Value-Label');
    chMfHolder_gender.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_gender_select"></select>`);

    // chMfHolder_department.querySelector('.chContent-BPG-group-Value-Label');
    // chMfHolder_department.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_department_select"></select>`);

    // chMfHolder_city.querySelector('.chContent-BPG-group-Value-Label');
    // chMfHolder_city.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_city_select"></select>`);

    // chMfHolder_district.querySelector('.chContent-BPG-group-Value-Label');
    // chMfHolder_district.insertAdjacentHTML('beforeend', `<select type="" title="" name="" id="chMfHolder_district_select"></select>`);

    // console.log(document.getElementById('chMfHolder_gender_select').value);
    const select_customer_gender = document.getElementById('chMfHolder_gender_select');
    // const select_customer_department = document.getElementById('chMfHolder_department_select');
    // const select_customer_city = document.getElementById('chMfHolder_city_select');
    // const select_customer_district = document.getElementById('chMfHolder_district_select');
    
    // Género
    if(gender_customer_options.includes(chMfHolder_gender.querySelector('textarea').value)){
      const index = gender_customer_options.indexOf(chMfHolder_gender.querySelector('textarea').value);
      gender_customer_options.splice(index, 1);
      gender_customer_options.unshift(chMfHolder_gender.querySelector('textarea').value);
    }

    if(chMfHolder_gender.querySelector('textarea').value){
      gender_customer_options.forEach(element => {
        select_customer_gender.insertAdjacentHTML('beforeend', `<option value="${element}">${element}</option>`);
      });
    } else {
      select_customer_gender.insertAdjacentHTML('beforeend', `<option value=""></option>`);
      gender_customer_options.forEach(element => {
        select_customer_gender.insertAdjacentHTML('beforeend', `<option value="${element}">${element}</option>`);
      });
    }
       
    select_customer_gender.addEventListener('change', function() {
      const gender_value = select_customer_gender.value;
      chMfHolder_gender.querySelector('textarea').value = gender_value;
    });  

    // // Departamento
    chMfHolder_department.querySelector('textarea').value = chMfHolder_department.querySelector('textarea').value.trim().toUpperCase();
    chMfHolder_department.querySelector('textarea').addEventListener('input', function() {
      this.value = this.value.toUpperCase();
    });
    
    if(chMfHolder_department.querySelector('textarea').value.trim()){

      // console.log(costa_rica[0]['provincias']);

      for (const departmentId in costa_rica[0]['provincias']) {
        if (costa_rica[0]['provincias'].hasOwnProperty(departmentId)) {
          const department = costa_rica[0]['provincias'][departmentId];
          // console.log(`Department ID: ${departmentId}`);
          // console.log(`Department Name: ${department.nombre}`);

          // console.log(department.nombre.toUpperCase());
          // console.log(chMfHolder_department.querySelector('textarea').value);

          if(department.nombre.toUpperCase().includes(chMfHolder_department.querySelector('textarea').value.trim())){   

            // console.log(department.cantones);

            for (const cantonIndex in department.cantones) {
              if (department.cantones.hasOwnProperty(cantonIndex)) {

                let canton_name = department.cantones[cantonIndex].nombre;             
           

                if(canton_name.toUpperCase().includes(chMfHolder_city.querySelector('textarea').value.trim())){
                  let city_selected = canton_name;
                  department.cantones.splice(cantonIndex, 1);
                  department.cantones.unshift(city_selected);
                }  

              }
            }
            
            // let department_selected = costa_rica[index];
            // costa_rica.splice(index, 1);
            // costa_rica.unshift(department_selected);
          }

          
       
        }
      }

     
    }






    // if(chMfHolder_department.querySelector('textarea').value === ""){
    //   select_customer_department.insertAdjacentHTML('beforeend', `<option value=""></option>`);
    // }

    // // console.log(costa_rica[0]['provincias']);

    // for (const provinciaKey in costa_rica[0]['provincias']){

      

    //   if(costa_rica[0]['provincias'].hasOwnProperty(provinciaKey)) {
    //     const provincia = costa_rica[0]['provincias'][provinciaKey];

       
    //     select_customer_department.insertAdjacentHTML('beforeend', `<option value="${provincia['nombre'].toUpperCase()}">${provincia['nombre'].toUpperCase()}</option>`);

    //     if(provincia['nombre'].toUpperCase() === department_customer){
    //       console.log(provincia);
    //       console.log(provincia['cantones']);

    //       for(const cantonKey in provincia['cantones']){

    //         if(provincia['cantones'].hasOwnProperty(cantonKey)) {

    //         const canton = provincia['cantones'][cantonKey];
    //         console.log('Cantón:', canton);

    //         if(canton['nombre'].toUpperCase().includes(chMfHolder_city.querySelector('textarea').value)){
    //           let city_selected = canton['nombre'];
    //           department.ciudades.splice(index, 1);
    //           department.ciudades.unshift(city_selected);
    //         } 

    //         }
    //       }
          

    //     }

       
    //   }
      
    // }

   
    // colombia.forEach((department) => {
    //     select_customer_department.insertAdjacentHTML('beforeend', `<option value="${department.departamento.toUpperCase()}">${department.departamento.toUpperCase()}</option>`);
    //     if(department.departamento.toUpperCase() === department_customer){
    //       department.ciudades.forEach((city, index) => {
    //         if(city.toUpperCase().includes(chMfHolder_city.querySelector('textarea').value)){
    //           let city_selected = city;
    //           department.ciudades.splice(index, 1);
    //           department.ciudades.unshift(city_selected);
    //         }   
    //       });

    //       department.ciudades.forEach(city => {
    //         select_customer_city.insertAdjacentHTML('beforeend', `<option value="${city.toUpperCase()}">${city.toUpperCase()}</option>`);
    //       });
    //     }              
    // });

    // console.log(colombia);
    // if(chMfHolder_department.querySelector('textarea').value === ""){
    //   select_customer_city.disabled = true;
    //   document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'gray';
    // } else {
    //   select_customer_city.disabled = false;
    //   document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'black';
    // }

    // select_customer_department.addEventListener('change', function() {
    //   const department_value = select_customer_department.value;
    //   chMfHolder_department.querySelector('textarea').value = department_value;

    //   if(chMfHolder_department.querySelector('textarea').value){
    //     console.log('TIENE VALOR');
    //     colombia.forEach((department) => {          
    //       if(department.departamento.toUpperCase() === department_value){
    //         select_customer_city.innerHTML = "";
    //         // select_customer_city.insertAdjacentHTML('beforeend', `<option value=""></option>`);
    //         department.ciudades.forEach(city => {
    //           select_customer_city.insertAdjacentHTML('beforeend', `<option value="${city.toUpperCase()}">${city.toUpperCase()}</option>`);
    //         });

    //         const city_value = select_customer_city.value;
    //         chMfHolder_city.querySelector('textarea').value = city_value;
    //       }       
    //     });
    //   } 

    //   if(chMfHolder_department.querySelector('textarea').value === ""){
    //     select_customer_city.disabled = true;
    //     document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'gray';
    //     chMfHolder_city_select.childNodes.forEach(e => {
    //       console.log(e);
    //       e.innerHTML = "";
    //     });
    //   }else {
    //     select_customer_city.disabled = false;          
    //     document.querySelector('#chMfHolder_city .chContent-BPG-group-Value-Label').style.color = 'black';
    //   }

    // }); 


    // select_customer_city.addEventListener('change', function() {
    //   const city_value = select_customer_city.value;
    //   chMfHolder_city.querySelector('textarea').value = city_value;
    // });


    // // Ciudad
    // chMfHolder_city.querySelector('textarea').value = chMfHolder_city.querySelector('textarea').value.toUpperCase();
    // chMfHolder_city.querySelector('textarea').addEventListener('input', function() {
    //   this.value = this.value.toUpperCase();
    // });

    // if(chMfHolder_city){
    //   chMfFields.appendChild(chMfHolder_city);
    // }
  }


});


// Activa el género si entra en una ruta que tenga Mujer. 
window.addEventListener('DOMContentLoaded', () => {

  
  var control_assign_event = false;
  var url_control = window.location.href;

  let url = window.location.pathname;

  if(url.includes('/products')){

    // console.log('Estamos en el PDP.');

    let man_action = document.getElementById('mhu');
    let woman_action = document.getElementById('mmu');

    let man_menu = document.querySelector('.menu-hombre');  
    let woman_menu = document.querySelector('.menu-mujer');

    let selected_gender;

    // Hace click de acuerdo con la URL:
    if(man_action && woman_action){
      if(location.href.includes('mujer')){
        woman_action.click();
      }
    
      if(man_action.dataset.selectedGender === 'hombre') {
        selected_gender = 'hombre';
        // console.log('Tiene seleccionado el género hombre.');
      } else {
        selected_gender = 'mujer';
        // console.log('Tiene seleccionado el género mujer.');
      }
    } else {
      // console.log('No tiene ambos botones');
      if(man_menu){
        selected_gender = 'hombre';
      } else if(woman_menu){
        // console.log(woman_menu);
        selected_gender = 'mujer';
      }else {
        selected_gender = 'ninos';
      }
    } 


     // Se agregó para que no fuera por el click ALERTA
     localStorage.setItem('size_type', 'us');

    // Crea el elemento: 
    let size_content = document.querySelector('.container-info-tallas .titles-mains');
    let change_size_btn = document.getElementById('pdp-change-size');
    var size_type = localStorage.getItem('size_type');

    
   
  
    // console.log('SIZE_TYPE:', size_type);
    // localStorage.setItem('size_type', '');

    if(!size_type || size_type.value === null){
      localStorage.setItem('size_type', 'eu');
      size_type = localStorage.getItem('size_type');
    }

    // console.log('GET ITEM:');
    // console.log(localStorage.getItem('size_type'));

    
    if(size_content && change_size_btn === null){
      if(localStorage.getItem('size_type') === 'us'){
          // console.log('Talla para pasar a Europea');
          size_content.insertAdjacentHTML('beforeEnd', '<span id="pdp-change-size">Talla Americana</span>');
          size_content.display = 'block';
      } else {
          // console.log('Talla para pasar a Americana');
          size_content.insertAdjacentHTML('beforeEnd', '<span id="pdp-change-size">Talla Europea</span>');
          size_content.display = 'block';
      }     
    }

    // console.log('Size Type:');
    // console.log(size_type);

    if(size_type){
      let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
      if(size_type === 'eu'){
        // document.getElementById('pdp-change-size').innerText = 'Talla Americana';           
        if(document.getElementById('pdp-change-size')) document.getElementById('pdp-change-size').innerText = 'Talla Americana';
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
      } else if (size_type === 'us') {
        if(document.getElementById('pdp-change-size')) document.getElementById('pdp-change-size').innerText = 'Talla Europea';        
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
      }

      let pdp_change_btn = document.getElementById('pdp-change-size');

      // console.log('PDP BTN:', pdp_change_btn);

      if(pdp_change_btn){
        // console.log('Asignando evento');
        pdp_change_btn.addEventListener('click', (event)=> {


          // console.log('SIZE TYPE: ', size_type.trim());

          // size_active = !size_active;

          if (size_type === 'eu') { 
            // console.log('SIZE TYPE EU: ', size_type.trim());
              document.getElementById('pdp-change-size').innerText = 'Talla Europea'; 
              localStorage.setItem('size_type', 'us');
              size_type = localStorage.getItem('size_type');
           } else { 
            // console.log('SIZE TYPE USA: ', size_type.trim());
              document.getElementById('pdp-change-size').innerText = 'Talla Americana'; 
              localStorage.setItem('size_type', 'eu'); 
              size_type = localStorage.getItem('size_type');
          }

          if(sizes_values){                    
            assignSizeValuesPDP(sizes_values, selected_gender, size_type);                  
          }
      

          // console.log('Click'); 
          event.preventDefault();
          event.stopPropagation();


        
        });
      }

      
    }    
  }


});


function assignSizeValuesPDP(sizes_values, selected_gender, size_type){

  // console.log(sizes_values);
  // console.log(selected_gender); 
  // console.log(size_type);

// Configuración de Regex: 
 const regex_woman = /mujer/i,
      regex_man   = /hombre/i,
      regex_kids  = /ninos/i,
      regex_jb    = /jibbitz/i;

  if(regex_woman.test(selected_gender)){
      // console.log('Tiene tallas de mujer');


      sizes_values.forEach(e => {
          
          if(size_type === 'us'){
              switch (e.innerText){
                  case '33':  e.innerText = '3';  break;
                  case '34':  e.innerText = '4';  break;
                  case '35':  e.innerText = '5';  break;
                  case '36':  e.innerText = '6';  break;
                  case '37':  e.innerText = '7';  break;
                  case '38':  e.innerText = '8';  break;
                  case '39':  e.innerText = '9';  break;
                  case '40':  e.innerText = '10'; break;
                  case '41':  e.innerText = '11'; break;
                  case '42':  e.innerText = '12'; break;
              }           
          } else {
              switch (e.innerText){
                  case '3':   e.innerText = '33'; break;
                  case '4':   e.innerText = '34'; break;
                  case '5':   e.innerText = '35'; break;
                  case '6':   e.innerText = '36'; break;
                  case '7':   e.innerText = '37'; break;
                  case '8':   e.innerText = '38'; break;
                  case '9':   e.innerText = '39'; break;
                  case '10':  e.innerText = '40'; break;
                  case '11':  e.innerText = '41'; break;
                  case '12':  e.innerText = '42'; break;
              }   
          }

      });
  } else if(regex_man.test(selected_gender)){
      sizes_values.forEach(e => {
        if(size_type === 'us'){
              switch (e.innerText){
                  case '34':  e.innerText = '3';  break;
                  case '35':  e.innerText = '4';  break;
                  case '36':  e.innerText = '5';  break;
                  case '37':  e.innerText = '6';  break;
                  case '38':  e.innerText = '7';  break;
                  case '39':  e.innerText = '8';  break;
                  case '40':  e.innerText = '9';  break;
                  case '41':  e.innerText = '10'; break;
                  case '42':  e.innerText = '11'; break;
                  case '43':  e.innerText = '12'; break;
                  case '44':  e.innerText = '13'; break;
                  case '45':  e.innerText = '14'; break;
                  case '46':  e.innerText = '15'; break;
              }           
          } else {         
              switch (e.innerText){
                  case '3':   e.innerText = '34'; break;
                  case '4':   e.innerText = '35'; break;
                  case '5':   e.innerText = '36'; break;
                  case '6':   e.innerText = '37'; break;
                  case '7':   e.innerText = '38'; break;
                  case '8':   e.innerText = '39'; break;
                  case '9':   e.innerText = '40'; break;
                  case '10':  e.innerText = '41'; break;
                  case '11':  e.innerText = '42'; break;
                  case '12':  e.innerText = '43'; break;
                  case '13':  e.innerText = '44'; break;
                  case '14':  e.innerText = '45'; break;
                  case '15':  e.innerText = '46'; break;
              }   
          }
      });
  } else if(regex_kids.test(selected_gender)){
      sizes_values.forEach(e => {
        // console.log('Talla: ', e.innerText);
          if(size_type === 'us'){
              switch (e.innerText){
                  case '21':  e.innerText = 'K3';  break;
                  case '22':  e.innerText = 'K4';  break;
                  case '23':  e.innerText = 'K5';  break;
                  case '24':  e.innerText = 'K6';  break;
                  case '25':  e.innerText = 'K7';  break;
                  case '26':  e.innerText = 'K8';  break;
                  case '27':  e.innerText = 'K9';  break;
                  case '28':  e.innerText = 'K10'; break;
                  case '29':  e.innerText = 'K11'; break;
                  case '30':  e.innerText = 'K12'; break;
                  case '31':  e.innerText = 'K13'; break;
                  case '32':  e.innerText = 'J1';  break;
                  case '33':  e.innerText = 'J2';  break;
                  case '34':  e.innerText = 'J3';  break;
                  case '35':  e.innerText = 'J4';  break;
                  case '36':  e.innerText = 'J5';  break;
                  case '37':  e.innerText = 'J6';  break;

                  // case '21':  e.innerText = 'K3';  break;
                  // case '22':  e.innerText = 'K4';  break;
                  // case '23':  e.innerText = 'K5';  break;
                  // case '24':  e.innerText = 'K6';  break;
                  // case '25':  e.innerText = 'K7';  break;
                  // case '26':  e.innerText = 'K8';  break;
                  // case '27':  e.innerText = 'K9';  break;
                  // case '28':  e.innerText = 'K10'; break;
                  // case '29':  e.innerText = 'K11'; break;
                  // case '30':  e.innerText = 'K12'; break;
                  // case '31':  e.innerText = 'K13'; break;
                  // case '32':  e.innerText = 'J1';  break;
                  // case '33':  e.innerText = 'J2';  break;
                  // case '34':  e.innerText = 'J3';  break;
                  // case '35':  e.innerText = 'J4';  break;
                  // case '36':  e.innerText = 'J5';  break;
                  // case '37':  e.innerText = 'J6';  break;
              }           
          } else {
              switch (e.innerText){
                  case '3':  e.innerText = '21'; break;
                  case '4':  e.innerText = '22'; break;
                  case '5':  e.innerText = '23'; break;
                  case '6':  e.innerText = '24'; break;
                  case '7':  e.innerText = '25'; break;
                  case '8':  e.innerText = '26'; break;
                  case '9':  e.innerText = '27'; break;
                  case '10': e.innerText = '28'; break;
                  case '11': e.innerText = '29'; break;
                  case '12': e.innerText = '30'; break;
                  case '13': e.innerText = '31'; break;
                  case 'J1':  e.innerText = '32'; break;
                  case 'J2':  e.innerText = '33'; break;
                  case 'J3':  e.innerText = '34'; break;
                  case 'J4':  e.innerText = '35'; break;
                  case 'J5':  e.innerText = '36'; break;
                  case 'J6':  e.innerText = '37'; break;
              }   
          }
      });
  }  
}


window.addEventListener('load', () => {
  // console.log('CARRITO CLEAR');

  let sizes = document.querySelectorAll('#CartDrawer-CartItems .drawer__cart-items-wrapper .cart-items tbody[role=rowgroup] .cart-item .cart-item__details dl .product-option dd');
  let size_type = localStorage.getItem('size_type');

  sizes?.forEach(size => {
    // console.log('tallas carrito');
    if(size_type === 'us'){

      // console.log('tallas carrito size type', size_type);

      switch (size.innerHTML.trim()){
          case 'H34':  size.innerHTML = 'M3';  break;
          case 'H35':  size.innerHTML = 'M4';  break;
          case 'H36':  size.innerHTML = 'M5';  break;
          case 'H37':  size.innerHTML = 'M6';  break;
          case 'H38':  size.innerHTML = 'M7';  break;
          case 'H39':  size.innerHTML = 'M8';  break;
          case 'H40':  size.innerHTML = 'M9';  break;
          case 'H41':  size.innerHTML = 'M10'; break;
          case 'H42':  size.innerHTML = 'M11'; break;
          case 'H43':  size.innerHTML = 'M12'; break;
          case 'H44':  size.innerHTML = 'M13'; break;
          case 'H45':  size.innerHTML = 'M14'; break;

          case 'M33':  size.innerHTML = 'W3';  break;
          case 'M34':  size.innerHTML = 'W4';  break;
          case 'M35':  size.innerHTML = 'W5';  break;
          case 'M36':  size.innerHTML = 'W6';  break;
          case 'M37':  size.innerHTML = 'W7';  break;
          case 'M38':  size.innerHTML = 'W8';  break;
          case 'M39':  size.innerHTML = 'W9';  break;
          case 'M40':  size.innerHTML = 'W10'; break;
          case 'M41':  size.innerHTML = 'W11'; break;
          case 'M42':  size.innerHTML = 'W12'; break;

          case 'H34-M35':  size.innerHTML = 'M3-W5';  break;
          case 'H35-M36':  size.innerHTML = 'M4-W6';  break;
          case 'H36-M37':  size.innerHTML = 'M5-W7';  break;
          case 'H37-M38':  size.innerHTML = 'M6-W8';  break;
          case 'H38-M39':  size.innerHTML = 'M7-W9';  break;
          case 'H39-M40':  size.innerHTML = 'M8-W10';  break;
          case 'H40-M41':  size.innerHTML = 'M9-W11';  break;
          case 'M41-M42':  size.innerHTML = 'M10-W12'; break;


          case 'K23':  size.innerHTML = 'C3'; break;

          case 'K22':  size.innerHTML = 'C4';  break;
          case 'K23':  size.innerHTML = 'C5';  break;
          case 'K24':  size.innerHTML = 'C6';  break;
          case 'K25':  size.innerHTML = 'C7';  break;
          case 'K26':  size.innerHTML = 'C8';  break;
          case 'K27':  size.innerHTML = 'C9';  break;
          case 'K28':  size.innerHTML = 'C10'; break;
          case 'K29':  size.innerHTML = 'C11'; break;
          case 'K30':  size.innerHTML = 'C12'; break;
          case 'K31':  size.innerHTML = 'C13'; break;

          case 'J32':  size.innerHTML = 'J1'; break;
          case 'J33':  size.innerHTML = 'J2'; break;
          case 'J34':  size.innerHTML = 'J3'; break;
          case 'J35':  size.innerHTML = 'J4'; break;
          case 'J36':  size.innerHTML = 'J5'; break;
          case 'J37':  size.innerHTML = 'J6'; break;


      }           
  } else {
      switch (size.innerHTML.trim()){
        case 'M3':  size.innerHTML = 'H34';  break;
        case 'M4':  size.innerHTML = 'H35';  break;
        case 'M5':  size.innerHTML = 'H36';  break;
        case 'M6':  size.innerHTML = 'H37';  break;
        case 'M7':  size.innerHTML = 'H38';  break;
        case 'M8':  size.innerHTML = 'H39';  break;
        case 'M9':  size.innerHTML = 'H40';  break;
        case 'M10': size.innerHTML = 'H41'; break;
        case 'M11': size.innerHTML = 'H42'; break;
        case 'M12': size.innerHTML = 'H43'; break;
        case 'M13': size.innerHTML = 'H44'; break;
        case 'M14': size.innerHTML = 'H45'; break;
        
        case 'W3':  size.innerHTML = 'M33';  break;
        case 'W4':  size.innerHTML = 'M34';  break;
        case 'W5':  size.innerHTML = 'M35';  break;
        case 'W6':  size.innerHTML = 'M36';  break;
        case 'W7':  size.innerHTML = 'M37';  break;
        case 'W8':  size.innerHTML = 'M38';  break;
        case 'W9':  size.innerHTML = 'M39';  break;
        case 'W10': size.innerHTML = 'M40'; break;
        case 'W11': size.innerHTML = 'M41'; break;
        case 'W12': size.innerHTML = 'M42'; break;
        
        case 'M3-W5':  size.innerHTML = 'H34-M35';  break;
        case 'M4-W6':  size.innerHTML = 'H35-M36';  break;
        case 'M5-W7':  size.innerHTML = 'H36-M37';  break;
        case 'M6-W8':  size.innerHTML = 'H37-M38';  break;
        case 'M7-W9':  size.innerHTML = 'H38-M39';  break;
        case 'M8-W10': size.innerHTML = 'H39-M40';  break;
        case 'M9-W11': size.innerHTML = 'H40-M41';  break;
        case 'M10-W12': size.innerHTML = 'M41-M42'; break;
        
        
        case 'C3': size.innerHTML = 'K23'; break;
        
        case 'C4':  size.innerHTML = 'K22';  break;
        case 'C5':  size.innerHTML = 'K23';  break;
        case 'C6':  size.innerHTML = 'K24';  break;
        case 'C7':  size.innerHTML = 'K25';  break;
        case 'C8':  size.innerHTML = 'K26';  break;
        case 'C9':  size.innerHTML = 'K27';  break;
        case 'C10': size.innerHTML = 'K28'; break;
        case 'C11': size.innerHTML = 'K29'; break;
        case 'C12': size.innerHTML = 'K30'; break;
        case 'C13': size.innerHTML = 'K31'; break;
        
        case 'J1': size.innerHTML = 'J32'; break;
        case 'J2': size.innerHTML = 'J33'; break;
        case 'J3': size.innerHTML = 'J34'; break;
        case 'J4': size.innerHTML = 'J35'; break;
        case 'J5': size.innerHTML = 'J36'; break;
        case 'J6': size.innerHTML = 'J37'; break;
        
      }   
  }

    // console.log(size.innerHTML.trim());
  });

});


/* Solución provisional para el Newsletter Promo */

// (()=> {
//   const announcementRef = document.querySelector('.announcement-bar__message[href="https://crocs.cr/account/register"]');
//   // let bannerRef = document.querySelector('.swiper-slide__link[href="/account/register"]');

//   // console.log(announcementRef);
  
//   if(announcementRef){
//     announcementRef.addEventListener('click', (e)=> {
//       e.preventDefault();
//       showModal();
//     });
//   }


//   // if(bannerRef){
    
//   //   bannerRef = bannerRef.parentNode;
//   //   bannerRef.style.cursor = 'pointer'; 

//   //   bannerRef.addEventListener('click', (e)=> {
//   //     e.preventDefault();
//   //     showModal();
//   //   });

//   //   bannerRef = bannerRef.parentNode.querySelectorAll('[href="/account/register"]');

//   //   console.log('Banner Ref', bannerRef);
    

//   //   bannerRef.forEach((element, index) => {
//   //     if(index === 1){
//   //       element.style.display = 'none';
//   //     }
//   //   });
//   // }

//   function showModal(){
//     const modal = document.getElementById('modal-newsletter');
//     console.log(modal);
    
//     if(modal) {
//       modal.style.display = 'flex';
//       localStorage.setItem('subscription', 'no');
//     }
//   };
// })();